import { render, staticRenderFns } from "./productquestiondetails.vue?vue&type=template&id=2aa6a7c2&scoped=true&"
import script from "./productquestiondetails.vue?vue&type=script&lang=js&"
export * from "./productquestiondetails.vue?vue&type=script&lang=js&"
import style0 from "./productquestiondetails.vue?vue&type=style&index=0&id=2aa6a7c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa6a7c2",
  null
  
)

export default component.exports